import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import {
  FETCH_ZONES, SET_ZONES, SET_FIELDS, UPDATE_ZONE,
} from './types';

const INITIAL_STATE = Immutable({
  loading: false,
  data: [],
  fields: null,
});

const setLoading = (state) => state.merge({
  ...state,
  loading: true,
});

const setZones = (state, { payload }) => state.merge({
  ...state,
  data: payload.map((item) => ({
    ...item,
    key: item._id,
  })),
  loading: false,
});

const setFields = (state, { payload }) => state.merge({
  ...state,
  fields: payload,
});

const updateZone = (state, { payload }) => state.merge({
  ...state,
  data: state.data.map((item) => {
    if (item._id === payload._id) {
      return {
        ...payload,
        key: payload._id,
      };
    }
    return { ...item };
  }),
});

const reducers = createReducer(INITIAL_STATE, {
  [FETCH_ZONES]: setLoading,
  [SET_ZONES]: setZones,
  [SET_FIELDS]: setFields,
  [UPDATE_ZONE]: updateZone,
});

export default reducers;
